export const LocalStorageService = {
  setTaskId: (taskId, integrationId)=>{
    localStorage.setItem(`task_id_${integrationId}`, taskId)
  },

  getTaskId: (integrationId)=>{
    return localStorage.getItem(`task_id_${integrationId}`)
  },
  
  setTaskStatus: (status, integrationId)=>{
    localStorage.setItem(`status_${integrationId}`, status)
  },

  getTaskStatus: (integrationId)=>{
    return localStorage.getItem(`status_${integrationId}`)
  },
  
  setTaskMessage: (message, integrationId)=>{
    localStorage.setItem(`message_${integrationId}`, message)
  },

  getTaskMessage: (integrationId)=>{
    localStorage.getItem(`message_${integrationId}`)
  }, 

  removeTaskStatus: (integrationId)=>{
    localStorage.removeItem(`status_${integrationId}`)
  },

  removeTaskId: (integrationId)=>{
    localStorage.removeItem(`task_id_${integrationId}`)
  },

  removeTaskMessage: (integrationId)=>{
    localStorage.removeItem(`message_${integrationId}`)
  },
  
  removeAll: (integrationId)=>{
    localStorage.removeItem(`task_id_${integrationId}`)
    localStorage.removeItem(`message_${integrationId}`)
    localStorage.removeItem(`status_${integrationId}`)
  }
};